import React from 'react';

import ExpandableJsonDetails from '../ExpandableJsonDetails';

interface Props {
  previous: Record<string, unknown> | null;
  proposed: Record<string, unknown>;
}

export default function TechnicalDetails({ previous, proposed }: Props) {
  return <ExpandableJsonDetails detail={{ previous, proposed }} testId="technical-details" />;
}
